import SeedRepository from "@/repositories/seedRepository";
import type { Seed, SeedUpdatePayload } from "@/types";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useAuthStore } from "./auth";

export const useSeedsStore = defineStore("seeds", () => {
  const seeds = ref<Seed[]>([]);
  const areSeedsLoaded = ref(false);

  async function getSeeds() {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return;
    seeds.value = await SeedRepository.getAll();
    areSeedsLoaded.value = true;
  }

  async function deleteSeed(seedId: number) {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return;
    await SeedRepository.delete(seedId);
    await getSeeds();
  }

  // Mark a packet as used up: keep the record but set its stock to 0.
  async function markOutOfStock(seed: Seed) {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return;
    const payload: SeedUpdatePayload = {
      expiry_year: seed.expiry_year,
      harvest_year: seed.harvest_year,
      origin: seed.origin,
      quantity: 0,
      quantity_kind: seed.quantity_kind,
      supplier: seed.supplier?.id ?? null,
      notes: seed.notes,
    };
    await SeedRepository.update(seed.id, payload);
    await getSeeds();
  }

  return { seeds, areSeedsLoaded, getSeeds, deleteSeed, markOutOfStock };
});
